import { getIsProductionalizeMobileFirstSummaryTableActive } from '@repo/hooks/featureFlags/featureFlags';
import { css } from '@repo/pandacss/styled-system/css';
import { type CSSProperties } from 'react';
import { getBestOfAwardsConfigForOffer } from '../BestOfAwards/utils';
import SummaryTable from '../SummaryTable';
import { filterEntitiesByState } from '../utils/geo-data';
import { SummaryTableSectionProps } from './types';

export function SummaryTableSection({
  allowTruncatingRows,
  allowTruncationWithFilters,
  deviceType,
  isFilterActive,
  isFilterLoading,
  maxRows,
  numTruncatedRows,
  pageType,
  regionCode,
  rows,
  shouldApplyStylingUpdates = false,
  showSkeleton,
  slug,
  pageUrl,
  suppressApyTermPrefix = false,
}: SummaryTableSectionProps) {
  if (!rows.length) {
    return null;
  }

  const rowsWithDrivers = regionCode ? filterEntitiesByState(rows, regionCode) : rows;

  if (!rowsWithDrivers.length) {
    return null;
  }

  const shouldShowMobileFirstSummaryTable = getIsProductionalizeMobileFirstSummaryTableActive(
    slug || '',
  );

  return (
    <section
      data-testid="summary-table-container"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        columnGap: '7',
        rowGap: '7',
        maxWidth: { base: 'full', md: '[82%]' },
        marginInlineStart: 'auto',
        marginInlineEnd: 'auto',
        marginBlockEnd: { base: '11', md: '16' },
        marginBlockStart: 'var(--margin-top)',
      })}
      style={
        {
          '--margin-top': isFilterActive ? '1rem' : '2.75rem',
        } as CSSProperties
      }
    >
      <div
        className={css({
          marginInlineStart: {
            base: 'var(--margin-x-xs)',
            lg: '0',
          },
          marginInlineEnd: {
            base: 'var(--margin-x-xs)',
            lg: '0',
          },
          width: 'full',
        })}
        style={
          {
            '--margin-x-xs': shouldShowMobileFirstSummaryTable ? '0' : '0.5rem',
          } as CSSProperties
        }
      >
        <SummaryTable
          isFilterActive={isFilterActive}
          shouldApplyStylingUpdates={shouldApplyStylingUpdates}
          showMobileLayout={shouldShowMobileFirstSummaryTable}
          showSkeleton={showSkeleton || isFilterLoading}
          rows={rowsWithDrivers}
          getBestOfAwardsConfig={(offerId, institutionId, subProductType) =>
            getBestOfAwardsConfigForOffer(
              offerId,
              slug ?? '',
              pageType,
              deviceType,
              institutionId,
              subProductType,
            )
          }
          pageUrl={pageUrl}
          suppressApyTermPrefix={suppressApyTermPrefix}
          maxRows={maxRows}
          numTruncatedRows={numTruncatedRows}
          allowTruncatingRows={allowTruncatingRows}
          slug={slug}
          allowTruncationWithFilters={allowTruncationWithFilters}
        />
      </div>
    </section>
  );
}
